import { PortfolioReviewSource } from "creso-core/types";

export const REVIEW_SOURCE_OPTIONS: {
  value: PortfolioReviewSource;
  label: string;
}[] = [
  { value: "ALL", label: "All holdings" },
  { value: "INTERNAL", label: "Internal holdings" },
  { value: "EXTERNAL", label: "External holdings" },
];

export const REVIEW_SOURCE_LABEL = Object.fromEntries(
  REVIEW_SOURCE_OPTIONS.map((o) => [o.value, o.label])
) as Record<PortfolioReviewSource, string>;

// Matches the backend's policy.DEFAULT_BENCHMARK.
export const DEFAULT_REVIEW_BENCHMARK = "NIFTY 500";

// Fund count the design calls the ideal range for a diversified portfolio.
export const IDEAL_FUND_COUNT = { min: 7, max: 12 };

export const ALLOCATION_COLORS = [
  "var(--color-chart-1)",
  "var(--color-chart-2)",
  "var(--color-chart-3)",
  "var(--color-chart-4)",
  "var(--color-chart-5)",
];
